import React, {
  useMemo,
  useState,
  useEffect,
  useRef,
  useCallback,
} from "react";
import { useTable } from "react-table";
import middleware from "../Api/Middleware";
import "./product.css";
import { useNavigate, useLocation } from "react-router";
import "../Main/Main.css";
import NavbarIcon from "../Navbars/Sidebar/Icons/globe.png";
import Loading from "../LoadingScreen/LoadingScreen";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCamera,
  faCaretUp,
  faCaretDown,
} from "@fortawesome/free-solid-svg-icons";
import Cookies from "universal-cookie";
import PageTemplate from "../Templates/PageTemplate";
import TablePreset from "../Table/TablePreset";
import SortableHeader from "../Table/TableComponents/SortableHeader";
import CheckboxHeader from "../Table/TableComponents/CheckboxHeader";
import CheckboxCell from "../Table/TableComponents/CheckboxCell";
import ErrorScreen from "../LoadingScreen/ErrorScreen";

//modals
import Modals from "./subpages/sub_components/VariationModals";
import Filters from "../Filters/Filters";
import ToastError from "../Toasts/ToastError";
import ToastSuccess from "../Toasts/ToastSuccess";
import generateLabel from "../generatePDF/GenerateLabel";
import ToastPromise from "../Toasts/ToastPromise";
import { use } from "react";
import { useSearchParams } from "react-router-dom";

function Products() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const cookies = new Cookies();
  const [loading, setLoading] = useState(true); // useState for page loading
  const [loadingPage, setLoadingPage] = useState(true);
  const [producten, setProducten] = useState([]); // useState for all products in the database
  const [brands, setBrands] = useState([]); // useState for all products in the database
  const [genders, setGenders] = useState([]); // useState for all products in the database
  const [suppliers, setSuppliers] = useState([]); // useState for all products in the database
  const [categories, setCategories] = useState([]); // useState for all products in the database
  const [seasons, setSeasons] = useState([]); // useState for all products in the database
  const [labelPrinterInstalled, setLabelPrinterInstalled] = useState(localStorage.getItem("labelPrinterInstalled") === "true");
  const [barcodes, setBarcodes] = useState([]); // useState for all products in the database
  const [stock, setStock] = useState([]); // useState for the stock of every Product in the database
  const [prices, setPrices] = useState([]); // useState for the prices of every Product in the database
  const [matchedVariationId, setMatchedVariationId] = useState(null);
  const [matchedVariation, setMatchedVariation] = useState(null);
  const [pagination, setPagination] = useState({
    page_size: parseInt(searchParams.get("page_size")||10),
    page: parseInt(searchParams.get("page")||1),
    max_items: 0,
    begin_of_page: 0,
    end_of_page: 0,
  }); // the useState for the pagination for the table
  const [order, setOrder] = useState({ orderBy: "", direction: "" }); // useState for ordering the columns in the table
  const [selectedProductIds, setSelectedProductIds] = useState([]); // usestate for the selected checkboxes
  const [fullyShownProducts, setFullyShownProducts] = useState([]); // usestate fpr the productname that u can fully show and shortend it
  const [showBlueprintModal, setShowBlueprintModal] = useState(false);
  const [inputValue, setInputValue] = useState();
  const [timerId, setTimerId] = useState(null);
  const [searchBarInput, setSearchBarInput] = useState("");
  const [productsSearchEngine, setProductsSearchEngine] = useState("");
  const [show, setShow] = useState(false);
  const [addColorOpen, setAddColorOpen] = useState(false);
  const [showReActivate, setShowReActivate] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [apiCheck, setApiCheck] = useState(true);
  const [apiError, setApiError] = useState("");
  const [duplicateInstalled, setDuplicateInstalled] = useState(JSON.parse(localStorage.getItem("appstore")));
  const [searchBar, setSearchBar] = useState(searchParams.get("search") || "");
  const [searchInput, setSearchInput] = useState(searchParams.get("search") || "");
  const defaultFilters = [
    {
      index: 0,
      order: 1,
      name: "Product type",
      field: "type",
      type: "radio",
      options: [
        { name: "Simpel", value: 1 },
        { name: "Variatie", value: 2 },
      ],
    },
    {
      index: 1,
      order: 2,
      name: "Afbeelding",
      field: "image_path",
      type: "hasradio",
      options: [
        { name: "Ja", value: 1 },
        { name: "Nee", value: 0 },
      ],
    },
    {
      index: 2,
      order: 3,
      name: "Prijs",
      field: "incl_tax,sale_incl_tax",
      type: "range",
      min: 0,
      max: null,
    },
    {
      index: 3,
      order: 4,
      name: "Voorraad",
      field: "stock",
      type: "hasradio",
      options: [
        { name: "Ja", value: 1 },
        { name: "Nee", value: 0 },
      ],
    },
    {
      index: 4,
      order: 5,
      name: "Status product",
      field: "status",
      type: "checkbox",
      value: [1],
      options: [
        { name: "Gepubliceerd", value: 1 },
        { name: "Gearchiveerd", value: 0 },
      ],
    },
    {
      index: 5,
      order: 6,
      name: "Merk",
      field: "brand",
      type: "dropdown",
      placeholder: "Selecteer merk",
      options: "brands",
    },
    {
      index: 6,
      order: 0,
      name: "Categorie",
      field: "categories",
      type: "category",
      checkedcats: [],
      placeholder: "Selecteer categorie",
      options: "categories",
    },
    {
      index: 7,
      order: 8,
      name: "Seizoen",
      field: "season",
      type: "dropdown",
      placeholder: "Selecteer seizoen",
      options: "seasons",
    },
    {
      index: 8,
      order: 9,
      name: "Geslacht",
      field: "gender",
      type: "dropdown",
      placeholder: "Selecteer geslacht",
      options: "genders",
    },
    {
      index: 9,
      order: 10,
      name: "Inkoopprijs",
      field: "buy_in_price",
      type: "hasradio",
      options: [
        { name: "Ja", value: 1 },
        { name: "Nee", value: 0 },
      ],
    },
    {
      index: 10,
      order: 11,
      name: "Barcode",
      field: "barcode",
      type: "hasradio",
      options: [
        { name: "Ja", value: 1 },
        { name: "Nee", value: 0 },
      ],
    },
    {
      index: 11,
      order: 12,
      name: "Korting",
      field: "sale_incl_tax",
      type: "hasradio",
      options: [
        { name: "Ja", value: 1 },
        { name: "Nee", value: 0 },
      ],
    },
  ];
  const [tempfilters, setTempFilters] = useState(defaultFilters);
  const [filters, setFilters] = useState(defaultFilters);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const filterString = () => {
    if (filters.filter((e) => e.value).length) {
      let string = "&filtering=type=1,2|";
      filters
        .filter((e) => e.value)
        .map((e) => {
          if (e.index == 4 && e.value.length == 0) {
            string += e.field;
            string += "=";
            string += "0";
            string += "|";
            console.log(string, e.value);
          }
          switch (e.type) {
            case "radio":
              string += e.field;
              string += "=";
              string += e.value;
              string += "|";

              break;
            case "hasradio":
              string += e.field;
              // For sale price (korting) the field may be null when no discount is set,
              // so use null comparison instead of numeric zero to detect presence.
              if (e.field === 'sale_incl_tax') {
                e.value == 0 ? (string += "=,null") : (string += "!=,null");
              } else {
                e.value == 0 ? (string += "=,0") : (string += "!=,0");
              }
              string += "|";

              break;
            case "range":
              if (e.value.min || e.value.max) {
                string += e.field;
                string += "<>";

                string +=
                  (e.value.min != null && e.value.min != ""
                    ? e.value.min
                    : "-1") + ",";
                string +=
                  e.value.max != null && e.value.max != ""
                    ? e.value.max
                    : "null";
                string += "|";
              }
              break;
            case "dropdown":
              string += e.field;
              string += "=";
              string += e.value;
              string += "|";
              break;
            case "category":
              string += e.field;
              string += "=";
              string += e.value;
              string += "|";
              break;
            case "season":
              string += e.field;
              string += "=";
              string += e.value;
              string += "|";
              break;
            case "checkbox":
              if (e.value.length > 0) {
                string += e.field;
                string += "=";
                string += e.value.join(",");
                string += "|";
              }
              break;
          }
        });
      return string;
    } else {
      return "";
    }
  };
  const CloseFilterModal = () => {
    setShowFilterModal(false);
  };
  // fetched all the products and the stock an the colors from the database
  const fetchAll = async () => {
    try {
      setLoading(true);
      const searchQuery = searchBar.trim()
        ? `&searchTerm=${encodeURIComponent(searchBar.trim())}&noSearch=["product_id","product_description","updated_at","created_at","image_path","type","status"]`
        : "";

      // Try dedicated barcode search endpoint first. If it returns a product (parent or variation),
      // use that result and skip the general listing call. If the endpoint is not available or
      // returns nothing, fall back to the normal listing.
      const trimmedSearch = searchBar.trim();
      if (trimmedSearch) {
        try {
          const barcodeResp = await middleware.get(
            `products/search-on-barcode?barcode=${encodeURIComponent(trimmedSearch)}`
          );
          const productResult = barcodeResp?.data?.data ?? barcodeResp?.data ?? null;
          if (productResult) {
            // Normalize to array for the table
            const productsArray = Array.isArray(productResult)
              ? productResult
              : [productResult];
            // Use returned product(s) as-is; per-cell rendering will prefer matched_variation fields when needed.
            setProducten(productsArray.map(product=>({...product,image_path:product.media[0].path})));
            const first = productsArray[0];
            setMatchedVariationId(first?.matched_variation_id ?? null);
            setMatchedVariation(first?.matched_variation ?? null);
            setPagination((prev) => ({
              ...prev,
              max_items: productsArray.length,
              begin_of_page: productsArray.length > 0 ? 1 : 0,
              end_of_page: productsArray.length,
            }));
            setLoading(false);
            setLoadingPage(false);
            return; // skip the normal fetch
          }
        } catch (err) {
          // Endpoint not available or failed — ignore and fall back to normal listing
        }
      }
      const [
        fetchProducts,
        fetchBrands,
        fetchCategories,
        fetchGenders,
        fetchSuppliers,
        fetchSeasons,
      ] = await Promise.all([
        middleware.get(
          `sp/productsTableAll?page=${pagination.page}&page_size=${pagination.page_size
          }${order.orderBy !== "" && order.direction !== ""
            ? `&orderBy=${order.orderBy}&orderDirection=${order.direction}`
            : ""
          }${searchQuery}` + filterString()
        ),
        middleware.get(`/products/brands?orderBy=name`),
        middleware.get(`/products/category?orderBy=title`),
        middleware.get(`/products/genders?orderBy=name`),
        middleware.get(`/suppliersdetail?orderBy=name`),
        middleware.get(`/products/seasons?orderBy=head_season`),
      ]);
      setProducten(fetchProducts.data.data); // sets the the data in the products usestate
      // Clear any matched-variation state when using the normal listing
      setMatchedVariationId(null);
      setMatchedVariation(null);
      setBrands(fetchBrands.data.data);
      setCategories(fetchCategories.data.data);
      setSeasons(fetchSeasons.data.data);
      setGenders(fetchGenders.data.data);
      setSuppliers(fetchSuppliers.data);
      setPagination({
        ...pagination,
        max_items: fetchProducts.data.total,
        begin_of_page: fetchProducts.data.from,
        end_of_page: fetchProducts.data.to,
      }); // sets the pagination usestate with the max items begin of the page and the end of the page
      setLoadingPage(false);
      setLoading(false);

      middleware.get(`apps?app_id=6`).then((res) => { // Check in the background if the label printer app is installed. No need to wait for this.
        const isInstalled = res.data.data.status === 3;
        localStorage.setItem("labelPrinterInstalled", isInstalled);
        setLabelPrinterInstalled(isInstalled);
      });
    } catch (error) {
      if (error?.response?.status === 401) {
        cookies.remove("token", { path: "/" });
        navigate("/");
      } else {
        setLoading(false);
        console.log(error);
        setApiCheck(false);
        if (error?.response?.data?.error != null) {
          setApiError(error.response.data.error);
        } else if (error.message != null) {
          setApiError(error.message);
        } else {
          setApiError("Er is een fout met het ophalen van de Api");
        }
      }
    }
  };

  // fetches all the data when pagination.page_size, pagination.page, order or location.pathname changes
  useEffect(() => {
    if (!loading) {
      fetchAll();
    }
  }, [
    pagination.page_size,
    pagination.page,
    order,
    location.pathname,
    filters,
    searchBar,
  ]);

  // Ensure the search input is populated from URL search params
  useEffect(() => {
    const s = searchParams.get("search") || "";
    setSearchBar(s);
    setSearchInput(s);
  }, [searchParams]);

  const formatPrice = (price) => {
    return new Intl.NumberFormat("nl-NL", {
      style: "currency",
      currency: "EUR",
    }).format(price);
  };

  // If the user searches for something specific this will set all the results in the table.
  useEffect(() => {
    try {
      if (productsSearchEngine.trim() === "" && productsSearchEngine === "") {
        // Code to fetch all when productsSearchEngine is empty
        fetchAll();
      } else if (productsSearchEngine.trim() !== "") {
        // Code to perform the search when productsSearchEngine has actual characters
        const doIt = async () => {
          const [fetchProducts] = await Promise.all([
            middleware.get(
              `${location.pathname === "/producten/alles"
                ? "sp/productsTableAll"
                : "sp/productsTableActive"
              }?page=${pagination.page}&page_size=${pagination.page_size
              }&searchTerm=${productsSearchEngine}&noSearch=["product_id","product_description","updated_at","created_at","image_path","type","status"]` +
              filterString()
            ),
          ]);
          setProducten(fetchProducts.data.data);
          setPagination({
            ...pagination,
            max_items: fetchProducts.data.total,
            begin_of_page: fetchProducts.data.from,
            end_of_page: fetchProducts.data.to,
          });
        };
        doIt();
      }
    } catch (error) {
      if (error.response.status === 401) {
        cookies.remove("token", { path: "/" });
        navigate("/");
      }
    }
  }, [productsSearchEngine]);

  // Handle checkbox selection
  const handleProductSelection = (productId, isSelected) => {
    if (isSelected) {
      setSelectedProductIds([...selectedProductIds, productId]);
    } else {
      setSelectedProductIds(
        selectedProductIds.filter((id) => id !== productId)
      );
    }
  };

  // Handle checkbox selection
  const handleSelection = (productId, isSelected) => {
    if (isSelected) {
      setSelectedIds((previous) => {
        // Only add if not already present
        if (!previous.includes(productId)) {
          return [...previous, productId];
        }
        return previous;
      });
    } else {
      setSelectedIds((previous) => previous.filter((id) => id !== productId));
    }
  };

  useEffect(() => {
    setProducten([]);
    setTimeout(() => {
      setProducten(producten);
      setLoading(false);
    }, 1);
  }, [fullyShownProducts]);

  const handleSearchChange = useCallback((value) => {
    setSearchBar(value);
    setPagination((prev) => ({ ...prev, page: 1 }));
  }, []);

  // Build edit URL
  const buildEditUrl = (id) => {
    return (
      `/producten/bewerken/${id}?page_size=${pagination.page_size}&page=${pagination.page}` +
      (searchBar ? `&search=${encodeURIComponent(searchBar)}` : "")
    );
  };

  //columns for the table
  const columns = useMemo(() => {
    let columnsArray = [
      {
        Header: (
          <CheckboxHeader
            currentItem={producten}
            selectedIds={selectedIds}
            setSelectedIds={setSelectedIds}
            pk={"product_id"}
          ></CheckboxHeader>
        ),
        accessor: "select",
        Cell: ({ row }) => {
          return (
            <CheckboxCell
              row={row}
              handleSelection={handleSelection}
              selectedIds={selectedIds}
              pk={"product_id"}
            />
          );
        },
      },
      {
        Header: (
          // image header (sortable)
          <SortableHeader
            currentItem={order}
            setItem={setOrder}
            field={"image_path"}
            pos={"center"}
          >
            Afbeelding
          </SortableHeader>
        ),
        accessor: "image_path",
        Cell: ({ row }) => {
          return (
            <>
              {/* Check if a product has a image, if yes then show the first image of the product if no then show a placeholder icon */}
              {row.original.image_path != null ? (
                <div
                  className="productPhoto align-content-center rounded d-flex justify-content-center align-items-center"
                  style={{ width: "45px", height: "45px" }}
                >
                  <img
                    src={
                      middleware.defaults.imagesBaseURL +
                      row.original.image_path
                    }
                    className="productImage rounded d-flex"
                    style={{ maxWidth: "45px", maxHeight: "45px" }}
                  />
                </div>
              ) : (
                <FontAwesomeIcon
                  icon={faCamera}
                  size="3x"
                  className="LightBlueText productPhoto align-self-center"
                />
              )}
            </>
          );
        },
      },
      {
        Header: () => (
          <div className="ms-5">
            <SortableHeader
              currentItem={order}
              setItem={setOrder}
              field={"product_name"}
              pos={"start"}
            >
              Productnaam
            </SortableHeader>
          </div>
          // <div
          //   onClick={e => setOrder({...order, orderBy: "product_name" , direction: `${order.direction === 'asc' ? (order.orderBy === "product_name" ? 'desc' : 'asc') : order.direction === 'desc' ? order.orderBy === 'product_name' ? '' : 'asc' : 'asc'}`})}
          // className="header-filter">
          //   Naam {order.orderBy === 'product_name' ?
          //   (order.direction === 'asc' ? <FontAwesomeIcon icon={faCaretUp} /> : order.direction === 'desc' ? <FontAwesomeIcon icon={faCaretDown}/> : '')
          //   : ''}
          // </div>
        ),
        accessor: "product_name",
        Cell: ({ row }) => {
          return (
            <span
              className="d-block align-content-center ms-5"
              style={{ height: "45px" }}
            >
              {row.original.product_name.length > 100 ? (
                fullyShownProducts.some(
                  (element) => element === row.original.product_id
                ) ? (
                  <>
                    <span
                      className="BlueText"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(buildEditUrl(row.original.product_id));
                      }}
                      onMouseDown={(event) => {
                        // sent user to new blank page on middle mouse btn click
                        if (event.button === 1) {
                          window.open(buildEditUrl(row.original.product_id), "_blank");
                        }
                      }}
                    >
                      {row.original.product_name}
                    </span>
                    <span
                      onClick={(e) => {
                        e.stopPropagation();
                        setFullyShownProducts(
                          fullyShownProducts.filter(
                            (id) => id !== row.original.product_id
                          )
                        );
                      }}
                      className="text-info hover text-nowrap ms-1"
                    >
                      Toon minder
                    </span>
                  </>
                ) : (
                  <>
                    <span
                      className="BlueText"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(buildEditUrl(row.original.product_id));
                      }}
                      onMouseDown={(event) => {
                        // sent user to new blank page on middle mouse btn click
                        if (event.button === 1) {
                          window.open(buildEditUrl(row.original.product_id), "_blank");
                        }
                      }}
                    >
                      {row.original.product_name.slice(0, 90)}
                    </span>
                    <span
                      onClick={(e) => {
                        setFullyShownProducts([
                          ...fullyShownProducts,
                          row.original.product_id,
                        ]);
                        setLoading(true);
                      }}
                      className="text-info hover text-nowrap ms-2"
                    >
                      (...)
                    </span>
                  </>
                )
              ) : (
                <span
                  className="BlueText cursorPointer d-block h-100 align-content-center"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(buildEditUrl(row.original.product_id));
                  }}
                  onMouseDown={(event) => {
                    // sent user to new blank page on middle mouse btn click
                    if (event.button === 1) {
                      window.open(buildEditUrl(row.original.product_id), "_blank");
                    }
                  }}
                >
                  {row.original.product_name}
                </span>
              )}
            </span>
          );
        },
      },
      {
        Header: () => (
          <div className="">
            <SortableHeader
              currentItem={order}
              setItem={setOrder}
              field={"incl_tax"}
              pos={"center"}
            >
              Prijs (incl. BTW)
            </SortableHeader>
          </div>
        ),
        accessor: "incl_tax",
        Cell: ({ row }) => {
          // Prefer parent prices, fallback to matched_variation prices if present
          const parent = row.original;
          const mv = parent.matched_variation ?? null;

          const getPriceFromPricesArray = (pricesArr, type) => {
            if (!Array.isArray(pricesArr)) return null;
            const it = pricesArr.find((p) => p.type === type);
            return it ? it.incl_tax : null;
          };

          // Try to find price in this order:
          // 1. Matched variation direct field
          // 2. Matched variation prices array
          // 3. Parent direct field
          // 4. Parent prices array
          let incl = mv?.incl_tax ?? 
                     getPriceFromPricesArray(mv?.prices, 'price') ?? 
                     parent.incl_tax ?? 
                     getPriceFromPricesArray(parent.prices, 'price');

          let sale = mv?.sale_incl_tax ?? 
                     getPriceFromPricesArray(mv?.prices, 'sale_price') ?? 
                     parent.sale_incl_tax ?? 
                     getPriceFromPricesArray(parent.prices, 'sale_price');

          // Normalize to numbers where possible
          incl = incl != null ? Number(String(incl).replace(',', '.')) : null;
          sale = sale != null ? Number(String(sale).replace(',', '.')) : null;
          if (Number.isNaN(incl)) incl = null;
          if (Number.isNaN(sale)) sale = null;

          return (
            <div className="text-center me-5 BlackText">
              {incl == null ? (
                <span>-</span>
              ) : sale == null ? (
                <span>{formatPrice(incl)}</span>
              ) : (
                <>
                  <s className="d-block">{formatPrice(incl)}</s>
                  <span className="d-block">{formatPrice(sale)}</span>
                </>
              )}
            </div>
          );
        },
      },
      {
        Header: () => (
          <SortableHeader
            currentItem={order}
            setItem={setOrder}
            field={"stock"}
            pos={"center"}
          >
            Voorraad
          </SortableHeader>
        ),
        accessor: "stock",
        Cell: ({ row }) => {
          const parent = row.original;
          const mv = parent.matched_variation ?? null;
          // prefer numeric parent.stock, else matched_variation stock
          let stockValue = null;
          if (parent.stock != null) {
            if (typeof parent.stock === 'object') {
              stockValue = parent.stock.commercial_quantity ?? parent.stock;
            } else {
              stockValue = parent.stock;
            }
          } else if (mv != null) {
            if (mv.stock != null) {
              stockValue = mv.stock.commercial_quantity ?? mv.stock;
            }
          }
          stockValue = stockValue != null ? Number(stockValue) : 0;
          if (Number.isNaN(stockValue)) stockValue = 0;
          return (
            <div className="text-center BlackText">{stockValue}</div>
          );
        },
      },
    ];
    return columnsArray;
  }, [order.orderBy, order.direction, selectedIds, setSelectedIds, producten]);

  // Table instance
  const tableInstance = useTable({ columns, data: producten || [] });

  // a function that selects all the selects in the table
  const select_all = () => {
    setSelectedIds(producten.map((product) => product.product_id));
  };

  // a function that unselects all the selects in the table
  const unselect_all = () => {
    setSelectedIds([]);
  };

  const deactivate_selected = async () => {
    try {
      // Put the products so that the selected ids products gets disabled
      const bulkData = [];
      producten
        .filter((product) => selectedIds.includes(product.product_id))
        .map((product) => {
          if (product.status !== 0) {
            bulkData.push({
              product_id: product.product_id,
              status: 0,
            });
            ToastSuccess('product(en) gearchiveerd', 'archivedProducts');
          } else {
            ToastError(
              "één of meerdere producten zijn al gearchiveerd",
              "alreadyArchivedProducts"
            );
          }
        });
      if (bulkData.length != 0) {
        await middleware.put(`/products`, {
          bulk_data: bulkData,
        });
      }

      await fetchAll();
    } catch (error) {
      console.log(error);
    }
  };

  const activate_selected = async () => {
    try {
      // Put the products so that the selected ids products gets disabled
      const bulkData = [];
      producten
        .filter((product) => selectedIds.includes(product.product_id))
        .map((product) => {
          if (product.status !== 1) {
            bulkData.push({
              product_id: product.product_id,
              status: 1,
            });
            ToastSuccess('product(en) gepubliceerd', 'publishedProduct');
          } else {
            ToastError(
              "één of meerdere producten zijn al gepubliceerd",
              "alreadyPublishedProducts"
            );
          }
        });
      if (bulkData.length != 0) {
        await middleware.put(`/products`, {
          bulk_data: bulkData,
        });
      }
      
      await fetchAll();
    } catch (error) {
      console.log(error);
    }
  };

  const duplicate_selected = async () => {
    if (selectedIds.length === 0) {
      ToastError("Selecteer ten minste één product om te dupliceren");
      return;
    }

    setLoading(true);

    let formattedProductIds = selectedIds.map((id) => ({ product_id: id }));

    await ToastPromise({
      promise: middleware.post('products/duplicate', {
        products: formattedProductIds
      }).then(async () => {
        await fetchAll();
        setSelectedIds([]);
        setLoading(false);
      }),
      pending: `${selectedIds.length} product${selectedIds.length > 1 ? 'en' : ''} dupliceren...`,
      successRenderer: () => {
        const count = selectedIds.length;
        return `${count} product${count > 1 ? 'en' : ''} succesvol gedupliceerd!`;
      },
      errorRenderer: (error) => {
        console.error("Failed to duplicate products:", error);
        setLoading(false);
        return error?.response?.data?.message || "Er is een fout opgetreden bij het dupliceren van de producten";
      },
      autoClose: 2000
    });
  };

  // handles when and wich buton is clicked
  const handleAction = (event) => {
    if (event === "suspend") {
      setShow(!show);
    } else if (event === "unsuspend") {
      setShowReActivate(!showReActivate);
    } else if (event === "select-all") {
      select_all();
    } else if (event === "unselect-all") {
      unselect_all();
    } else if (event === "deactivate-selected") {
      deactivate_selected();
    } else if (event === "activate-selected") {
      activate_selected();
    } else if (event === "duplicate") {
      duplicate_selected();
    }
  };

  //save page, page_size and search in search params so when user goes back to the page the pagination is the same as they left it
  useEffect(() => {
    setSearchParams({ page: pagination.page, page_size: pagination.page_size, search: searchBar });
  }, [pagination.page, pagination.page_size, searchBar]);

  if (!apiCheck) {
    return <ErrorScreen error={apiError} />;
  }
  return (
    <PageTemplate
      navbarTitle={"Warehouse HUB"}
      pageIsLoading={loadingPage}
      hideBackButton={true}
    >
      <div className="productOverview">
        <Modals
          show={show}
          openAddColor={addColorOpen}
          setOpenAddColor={setAddColorOpen}
          handleClose={(e) => setShow(false)}
          redirect={`/producten/nieuw/variatie?page_size=${pagination.page_size}&page=${pagination.page}${searchBar ? `&search=${encodeURIComponent(searchBar)}` : ""}`}
        />
        <div className="productTable w-100">
          <TablePreset
            data={[
              {
                selectedIds: selectedIds,
                tableInstance: tableInstance,
                pagination: pagination,
                inputValue: searchInput,
              },
            ]}
            tableLoading={loading}
            setPagination={(e) => setPagination(e)}
            handleSelection={handleSelection}
            primary_key={"product_id"}
            searchBar={[
              {
                shown: true,
                searchFunction: handleSearchChange,
                placeholder: "Zoeken op product, merk, etc.",
                inputValue: searchInput,
                setInputValue: setSearchInput,
              },
            ]}
            actionOptions={[
              ...(labelPrinterInstalled ? [{ // Removes the label printing option if its not installed
                title: 'Label(s) printen',
                function: () => generateLabel(selectedIds),
              }] : []),
              {
                title: "Producten publiceren",
                function: () => handleAction("activate-selected"),
              },
              {
                title: "Producten archiveren",
                function: () => handleAction("deactivate-selected"),
              },
              ...(duplicateInstalled?.apps?.find(app => app.slug === "duplicate-products")?.status === 3 ? [{
                title: "Producten dupliceren",
                function: () => handleAction("duplicate"),
              }] : []),
              ...(duplicateInstalled?.apps?.find(app => app.slug === "sale")?.status === 3 ? [{
                title: "Kortingsactie starten",
                function: () => navigate("/appstore/sale", { state: { selectedProductIds: selectedIds } }),
              }] : [])
            ]}
            leftButtons={[
              { title: "Filteren", function: () => setShowFilterModal(true) },
            ]}
            rightButtons={[
              {
                title: "Nieuw simpel product",
                function: () => navigate(`/producten/nieuw?page_size=${pagination.page_size}&page=${pagination.page}${searchBar ? `&search=${encodeURIComponent(searchBar)}` : ""}`),
              },
              {
                title: "Nieuw variatie product",
                function: () => setShow(true),
              },
            ]}
          />
        </div>
      </div>
      <Filters
        filters={tempfilters}
        props={{
          brands: brands.map((e) => {
            return { name: e.name, value: e.brand_id };
          }),
          categories: categories.map((e) => {
            return {
              primary_key: e.primary_key,
              id: e.category_id,
              headId: e.head_category_id,
              name: e.title,
            };
          }),
          genders: genders.map((e) => {
            return { name: e.name, value: e.gender_id };
          }),
          seasons: seasons.map((e) => {
            return { name: `${e.head_season} ${e.sub_season ?? ''}`, value: e.season_id };
          }),
          suppliers: suppliers.map((e) => {
            return { name: "", value: e.supplier_id };
          }),
          suppliers: suppliers.map((e) => {
            return { name: e.company.company_name, value: e.supplier_id };
          }),
        }}
        showFilterModal={showFilterModal}
        closeFilterModal={CloseFilterModal}
        setTempFilters={setTempFilters}
        setFilters={setFilters}
        defaultFilters={defaultFilters}
      />
    </PageTemplate>
  );
}

export default Products;